import mixpanel from "mixpanel-browser"
import { isAnalyticsSuppressed } from "./analyticsSuppression"
import { IS_PRODUCTION_ENV } from "./environment"

/** Sends an event to Mixpanel + GA4. Drops silently when suppressed. */
export function trackEvent(
  name: string,
  payload: Record<string, unknown> = {}
) {
  if (!IS_PRODUCTION_ENV) return
  try {
    if (isAnalyticsSuppressed()) return
  } catch {
    // Suppression is privacy-critical, so fail closed.
    return
  }

  try {
    mixpanel.track(name, payload)
  } catch {
    // Mixpanel not initialized yet, skip
  }

  try {
    window.gtag?.("event", name, payload)
  } catch {
    // GA4 not initialized yet, skip
  }
}
